(() => {
  const blocks = document.querySelectorAll('[data-premium-price]');

  if (!blocks.length) return;

  const formatMoney = (cents, currencyCode, currencySymbol) => {
    const amount = Number(cents) / 100;
    const number = new Intl.NumberFormat(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);

    return `${currencySymbol}${number} ${currencyCode}`;
  };

  const findVariantId = (block) => {
    const productInfo = block.closest('product-info');
    const form = productInfo?.querySelector('form[action*="/cart/add"]')
      || document.querySelector('form[action*="/cart/add"]');

    const variantInput = form?.querySelector('input[name="id"]');
    return variantInput?.value || block.dataset.currentVariantId;
  };

  const updatePriceBlock = (block) => {
    let variants;

    try {
      variants = JSON.parse(block.dataset.variantPrices || '[]');
    } catch (error) {
      console.error('Unable to read product variant prices.', error);
      return;
    }

    const variantId = String(findVariantId(block));
    const variant = variants.find((item) => String(item.id) === variantId);

    if (!variant) return;

    const currentPrice = Number(variant.price) || 0;
    const comparePrice = Number(variant.compare_at_price) || 0;
    const isDiscounted = comparePrice > currentPrice;
    const savingsAmount = isDiscounted ? comparePrice - currentPrice : 0;
    const savingsPercent = isDiscounted
      ? Math.round((savingsAmount * 100) / comparePrice)
      : 0;

    const label = block.querySelector('[data-price-label]');
    const badge = block.querySelector('[data-price-badge]');
    const badges = block.querySelector('[data-price-badges]');
    const currentPriceElement = block.querySelector('[data-current-price]');
    const comparePriceElement = block.querySelector('[data-compare-price]');
    const savingCopy = block.querySelector('[data-saving-copy]');
    const currencyCode = block.dataset.currencyCode || 'CAD';
    const currencySymbol = block.dataset.currencySymbol || '$';

    if (label) {
      label.textContent = isDiscounted ? 'Special price' : 'Price';
    }

    if (currentPriceElement) {
      currentPriceElement.textContent = formatMoney(currentPrice, currencyCode, currencySymbol);
    }

    if (comparePriceElement) {
      comparePriceElement.classList.toggle('is-hidden', !isDiscounted);
      comparePriceElement.innerHTML = isDiscounted
        ? `<span class="visually-hidden">Regular price:</span>${formatMoney(comparePrice, currencyCode, currencySymbol)}`
        : '';
    }

    if (badges) {
      badges.hidden = !isDiscounted;
    }

    if (badge) {
      badge.textContent = isDiscounted ? `Save ${savingsPercent}%` : '';
    }

    if (savingCopy) {
      savingCopy.classList.toggle('is-hidden', !isDiscounted);
      savingCopy.textContent = isDiscounted
        ? `You save ${formatMoney(savingsAmount, currencyCode, currencySymbol)} today.`
        : '';
    }

    block.dataset.currentVariantId = variant.id;
  };

  const updateAll = () => blocks.forEach(updatePriceBlock);

  document.addEventListener('change', (event) => {
    if (event.target.matches('variant-selects select, variant-radios input, input[name="id"]')) {
      window.setTimeout(updateAll, 0);
    }
  });

  document.addEventListener('variant:change', updateAll);
  document.addEventListener('shopify:section:load', updateAll);

  updateAll();
})();
